const getBaseUrl = () => {
    const currentDomain = window.location.hostname;
    if (currentDomain === 'localhost') {
        return 'http://localhost:5000';
    } else if(currentDomain === 'test.bhojanshala.in') {
        return `https://${currentDomain}/test-api`;
    } else {
        return `https://${currentDomain}/api`;
    }
};

const baseUrl = getBaseUrl();
const limit = 20;
const batchSize = 5;
// How many batch rows Rotli Production opens with. Was 30, from when the screen laid out a fixed
// set of batches and had no way to ask for another; it now has an Add Batch button, and a day that
// has already saved more than this shows all of them, so the number only decides how many empty
// rows are waiting on arrival. Thirty of those on a phone was a long scroll to nowhere.
const rotiBatchSize = 5;

const timeSlotList = [
    { value: "4 to 5am", label: "4 to 5am" },
    { value: "5 to 6am", label: "5 to 6am" },
    { value: "6 to 7am", label: "6 to 7am" },
    { value: "7 to 8am", label: "7 to 8am" },
    { value: "8 to 9am", label: "8 to 9am" },
    { value: "9 to 10am", label: "9 to 10am" },
    { value: "10 to 11am", label: "10 to 11am" },
    { value: "11 to 12am", label: "11 to 12am" },
    { value: "12 to 1am", label: "12 to 1am" },
    { value: "1 to 2pm", label: "1 to 2pm" },
    { value: "2 to 3pm", label: "2 to 3pm" },
    { value: "3 to 4pm", label: "3 to 4pm" },
    { value: "4 to 5pm", label: "4 to 5pm" },
    { value: "5 to 6pm", label: "5 to 6pm" },
    { value: "6 to 7pm", label: "6 to 7pm" },
    { value: "7 to 8pm", label: "7 to 8pm" },
    { value: "8 to 9pm", label: "8 to 9pm" },
];

const timeList = [
    { value: "1 AM", label: "1 AM" },
    { value: "1:30 AM", label: "1:30 AM" },
    { value: "2 AM", label: "2 AM" },
    { value: "2:30 AM", label: "2:30 AM" },
    { value: "3 AM", label: "3 AM" },
    { value: "3:30 AM", label: "3:30 AM" },
    { value: "4 AM", label: "4 AM" },
    { value: "4:30 AM", label: "4:30 AM" },
    { value: "5 AM", label: "5 AM" },
    { value: "5:30 AM", label: "5:30 AM" },
    { value: "6 AM", label: "6 AM" },
    { value: "6:30 AM", label: "6:30 AM" },
    { value: "7 AM", label: "7 AM" },
    { value: "7:30 AM", label: "7:30 AM" },
    { value: "8 AM", label: "8 AM" },
    { value: "8:30 AM", label: "8:30 AM" },
    { value: "9 AM", label: "9 AM" },
    { value: "9:30 AM", label: "9:30 AM" },
    { value: "10 AM", label: "10 AM" },
    { value: "10:30 AM", label: "10:30 AM" },
    { value: "11 AM", label: "11 AM" },
    { value: "11:30 AM", label: "11:30 AM" },
    { value: "12 AM", label: "12 AM" },
    { value: "12:30 AM", label: "12:30 AM" },
    { value: "1 PM", label: "1 PM" },
    { value: "1:30 PM", label: "1:30 PM" },
    { value: "2 PM", label: "2 PM" },
    { value: "2:30 PM", label: "2:30 PM" },
    { value: "3 PM", label: "3 PM" },
    { value: "3:30 PM", label: "3:30 PM" },
    { value: "4 PM", label: "4 PM" },
    { value: "4:30 PM", label: "4:30 PM" },
    { value: "5 PM", label: "5 PM" },
    { value: "5:30 PM", label: "5:30 PM" },
    { value: "6 PM", label: "6 PM" },
    { value: "6:30 PM", label: "6:30 PM" },
    { value: "7 PM", label: "7 PM" },
    { value: "7:30 PM", label: "7:30 PM" },
    { value: "8 PM", label: "8 PM" },
    { value: "8:30 PM", label: "8:30 PM" },
    { value: "9 PM", label: "9 PM" },
    { value: "9:30 PM", label: "9:30 PM" },
    { value: "10 PM", label: "10 PM" },
    { value: "10:30 PM", label: "10:30 PM" },
    { value: "11 PM", label: "11 PM" },
    { value: "11:30 PM", label: "11:30 PM" },
    { value: "12 PM", label: "12 PM" },
    { value: "12:30 PM", label: "12:30 PM" }
];


const rotliTypeList = [
    { id: 1, label: "Machine" },
    { id: 2, label: "Swaminarayan" },
    { id: 3, label: "Manual" }
];

const noOfGullaList = [
    { id: 1, label: "1" },
    { id: 2, label: "2" },
    { id: 3, label: "3" },
    { id: 4, label: "4" },
    { id: 5, label: "5" },
    { id: 6, label: "6" }
];


const generateRequisitionNumber = (index, activeIndex, date, session, mealList, vesselList, vessel) => {
    // console.log(vessel);
    const today = new Date(date);
    // console.log(today)
    const day = today.getDate().toString().padStart(2, '0'); // Get day and pad with leading zero if needed
    const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Get month (Note: January is 0, so add 1) and pad with leading zero if needed
    const year = today.getFullYear().toString().slice(-2);
    // const dayOfMonth = today.getDate();
    const ddmmyy = `${day}${month}${year}`;
    const sessionName = session.label.charAt(0);
    const item = mealList.find((item, index) => index == activeIndex);
    const itemName = item.eng_name.replace(/\s/g, "-");
    const vesselName = vesselList.find((item) => item.id == vessel)?.name ?? "-";
    const requisition_no = ddmmyy + "/" + sessionName + "/" + itemName + "/" + vesselName + "-" + index;
    return requisition_no;

}

const getDateWithDay = (date) => {
    const dateObj = new Date(date);
    const formattedDate = new Intl.DateTimeFormat('en', { day: '2-digit', month: 'short', year: 'numeric', weekday: 'short' }).format(dateObj);
    return formattedDate;
}

const reportTypeList = [
    { id: 1, label: "Detailed" },
    { id: 2, label: "Production" },
    { id: 3, label: "Summary" },
];

const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).format(date);
};

// A computed quantity, without the tail that binary floating point leaves on it. 904.12 - 900 is
// 4.1200000000000045 in JavaScript, and that is what Required Qty was showing the storekeeper.
// Three decimals is what the quantity columns carry.
const roundQty = (value, decimals = 3) => {
    const number = Number(value);
    return Number.isFinite(number) ? parseFloat(number.toFixed(decimals)) : 0;
};

// A dairy quantity counted two ways. Crates come from the count divided by the ingredient's
// Std. Qty. per Crate, and the count comes back by multiplying it again, so entering either one
// fills in the other. Both are rounded -- a float division left as it comes reads
// 3.3299999999999996 in a form field -- and both give back '' for an empty box, so clearing one
// clears the other rather than writing a 0 the storekeeper did not type.
const qtyToCrates = (qty, stdQtyPerCrate) =>
    qty === '' || qty === null || qty === undefined || !stdQtyPerCrate
        ? ''
        : parseFloat((Number(qty) / Number(stdQtyPerCrate)).toFixed(2));

const cratesToQty = (crates, stdQtyPerCrate) =>
    crates === '' || crates === null || crates === undefined || !stdQtyPerCrate
        ? ''
        : parseFloat((Number(crates) * Number(stdQtyPerCrate)).toFixed(3));

// A dairy count read in Ltrs / Kgs: the theli/packet count the Issue and Return screens store,
// times the ingredient's Std. Qty. per Crate - Ltrs. / Kgs. An ingredient with no crate size has
// nothing to convert against and keeps the count it has, rather than being multiplied down to 0.
const qtyToLtrsKgs = (qty, stdQtyPerCrate) =>
    qty === '' || qty === null || qty === undefined
        ? ''
        : parseFloat((Number(qty) * (Number(stdQtyPerCrate) > 0 ? Number(stdQtyPerCrate) : 1)).toFixed(3));

// The dairy screens read their dates back as DD-MM-YYYY.
//
// A plain calendar date is reordered by string rather than by Date: new Date('2026-09-04') is
// parsed as UTC midnight, which is still the 3rd anywhere west of Greenwich. Anything carrying a
// time -- a MySQL DATE handed back by the driver arrives as a full ISO timestamp -- goes through
// Date, where the local reading is the right one.
const formatDateDMY = (dateString) => {
    if (!dateString) return '';
    const calendarDate = String(dateString).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (calendarDate) {
        const [, year, month, day] = calendarDate;
        return `${day}-${month}-${year}`;
    }
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? String(dateString) : formatDate(date).replace(/\//g, '-');
};

// The same date, spelled so it can go in a filename.
//
// formatDate is en-GB, which means 30/07/2023 -- and a slash cannot appear in a filename. Handed
// one, the browser rewrites it while saving the download, so the file that lands is not the name
// the code asked for and no two browsers need agree on the result. Building the name with
// underscores up front makes it predictable: 30_07_2023.
const formatDateForFile = (dateString) => formatDate(dateString).replace(/\//g, '_');

const requirementStatusList = [
    { value: 0, label: "All" },
    { value: 1, label: "Pending Requirement" },
    { value: 2, label: "Submitted for Order" },
];
const orderStatusList = [
    { value: 0, label: "All" },
    { value: 1, label: "Pending Order" },
    { value: 3, label: "Order Place" },
];
const purchaseStatusList = [
    { value: 0, label: "All" },
    { value: 1, label: "Pending Purchase" },
    { value: 3, label: "Purchased" },
];
const receiptStatusList = [
    { value: 0, label: "All" },
    { value: 1, label: "Pending Receipt" },
    { value: 2, label: "Partly Received" },
    { value: 3, label: "Received" },
    { value: 4, label: "Excess Received" },
];
const dairyReceiptStatusList = [
    { value: 0, label: "All" },
    { value: 1, label: "Pending Receipt" },
    { value: 2, label: "Partly Received" },
    { value: 3, label: "Received" },
    { value: 4, label: "Excess Received" },
];

const issueStatusList = [
    { value: 0, label: "All" },
    { value: 1, label: "Pending Issue" },
    { value: 2, label: "Partly Issued" },
    { value: 3, label: "Issued" },
];

const returnReceiptStatusList = [
    { value: 0, label: "All" },
    { value: 1, label: "Pending Receipt" },
    { value: 2, label: "Partly Received" },
    { value: 3, label: "Received" },
]

const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};

const appropriateItemSeason = [
    { value: 0, label: "Winter season (Nov, Dec, Jan, Feb)" },
    { value: 1, label: "Summer season (Mar, April, May, June)" },
    { value: 2, label: "Rainy season (July, Aug, Sept, Oct)" },
    { value: 3, label: "All season" }
]

const mahatmaRatings = [
    { value: 4, label: "Excellent" },
    { value: 3, label: "Good" },
    { value: 2, label: "Average" },
    { value: 1, label: "Poor" },
    { value: 0, label: "Very Poor" }
];

const heightSelectionList = [
    { value: 1, label: "Filled Height" },
    { value: 2, label: "Empty Height" },
];


// The Active/Inactive dropdown every master list and form uses.
const statusList = [
    { value: 1, label: "Active" },
    { value: 0, label: "Inactive" },
];

// Common decimal formatting utility
// Parameters: value, fieldName, zeroDecimalFields (array), threeDecimalFields (array, optional)
const formatReportValue = (value, fieldName, zeroDecimalFields = [], threeDecimalFields = []) => {
    if (value === null || value === undefined || value === '-' || value === '') {
        return value;
    }

    const numValue = parseFloat(value);
    if (isNaN(numValue)) {
        return value;
    }

    if (zeroDecimalFields.includes(fieldName)) {
        return Math.round(numValue);
    }

    if (threeDecimalFields.includes(fieldName)) {
        return numValue.toFixed(3);
    }

    // Default to 2 decimal places
    return numValue.toFixed(2);
};

// Master Report field configuration
// 0 decimal: Planned count, Batch, Food Qty, Persons Per bowl, Food Qty.(Bowl based), Pass Issued, Dish issued, Final Dish count, Avg persons per bowl
// 3 decimal: Std.RM to FG Ratio, Current RM to FG Ratio, Std FG Consump. per person, Std. RM to Bowl Ratio, Current RM to Bowl Ratio, FG consump. Per Person, Raw Mat. Per 100 Person, Std Density, Live Density
const masterZeroDecimalFields = ['estimated_count', 'batch', 'food_qty', 'person_per_bowl', 'food_qty_bowl', 'pass_issued', 'dish_issue_count', 'final_dish_count', 'avg_person_per_bowl', 'excess_fg_persons', 'net_excess_fg_persons', 'production_count'];
// #6: Actual FG / person (fg_consumption_per_person) rounds to 2 decimals, so it is intentionally NOT in the 3-decimal list.
const masterThreeDecimalFields = ['rm_to_fg_ratio', 'current_rm_to_fg_ratio', 'std_fg_consumption_per_person', 'std_rm_to_bowl_ratio', 'current_rm_to_bowl_ratio', 'raw_mat_per_100_person', 'std_density', 'density', 'planned_rm_to_fg_ratio'];
const formatMasterReportValue = (value, fieldName) => formatReportValue(value, fieldName, masterZeroDecimalFields, masterThreeDecimalFields);

// Production Report: 0 decimal: Production (Persons), Estimated (Persons), Persons per bowl
const productionZeroDecimalFields = ['food_qty', 'estimated_count', 'person_per_bowl'];
const formatProductionReportValue = (value, fieldName) => formatReportValue(value, fieldName, productionZeroDecimalFields);

// Excess Report: 0 decimal: Estimated (Persons), Production (Persons), Pass Issued, Dish count
const excessZeroDecimalFields = ['estimated_count', 'food_qty', 'pass_issued', 'final_dish_count'];
const formatExcessReportValue = (value, fieldName) => formatReportValue(value, fieldName, excessZeroDecimalFields);

// Summary Report: 0 decimal: Estimated, Production, Pass Issued, Dish Issued, Avg persons per bowl (STD/Actual)
// 3 decimal: FG consumption per person, RM to FG Ratio, Raw Material to Bowl ratio, Density (all STD/Actual)
const summaryZeroDecimalFields = ['estimated_count', 'food_qty', 'pass_issued', 'final_dish_count', 'std_avg_person_per_bowl', 'person_per_bowl'];
const summaryThreeDecimalFields = ['std_fg_consumption_per_person', 'fg_consumption_per_person', 'rm_to_fg_ratio', 'current_rm_to_fg_ratio', 'std_rm_to_bowl_ratio', 'current_rm_to_bowl_ratio', 'std_density', 'density'];
const formatSummaryReportValue = (value, fieldName) => formatReportValue(value, fieldName, summaryZeroDecimalFields, summaryThreeDecimalFields);

// Recipe Feedback Report: 0 decimal: Estimated count, Pass Issued, Dish issued
const recipeFeedbackZeroDecimalFields = ['estimated_count', 'pass_issued', 'dish_issue_count'];
const formatRecipeFeedbackReportValue = (value, fieldName) => formatReportValue(value, fieldName, recipeFeedbackZeroDecimalFields);

// Finished Goods field configuration
// 0 decimal: Gulla count, No. of Rotis/Bhakhari, Total No. of Rotis/Bhakhari
// 2 decimal: All other numeric fields (Ltrs, Kgs, Nos measurements)
const finishedGoodsZeroDecimalFields = [
    'gulla_count',
    'no_of_roti_bhakhri', 
    'total_no_of_roti_bhakhri'
];
const finishedGoodsTwoDecimalFields = [
    // Actual Raw Material Qty
    'actual_raw_material_qty_kgs',
    'actual_raw_material_qty_ltr',
    'actual_raw_material_qty_nos',
    'batch_raw_qty',
    
    // For Ltrs
    'vessel_diameter',
    'height',
    'sensor_volume',
    'manual_volume',
    'batch_volume',
    'total_manual_volume',
    
    // For Kgs
    'gross_weight_fg',
    'weight_of_empty_trolly',
    'weight_of_empty_vessel',
    'net_weight',
    'total_net_weight',
    
    // For Nos
    'fg_qty',
    'gulla_weight',
    'avg_finished_roti_weight',
    'weight_of_1_filled_bowl',
    'rotis_in_1_icebox_bowl',
    'current_raw_to_fg_multiplier',
    'std_raw_atta_to_finished_atta_multiplier',
    'readymade_nos_qty',
    'weight_of_1_readymade_no',
    'weight_of_1_empty_bowl',
    'net_weight_of_filled_bowl'
];
const formatFinishedGoodsValue = (value, fieldName) => {
    return formatReportValue(value, fieldName, finishedGoodsZeroDecimalFields, []);
};

// Helper function to format all numeric fields in formData for Finished Goods
const formatFinishedGoodsFormData = (formDataItem) => {
    const formatted = { ...formDataItem };
    
    // Format zero decimal fields
    finishedGoodsZeroDecimalFields.forEach(field => {
        if (formatted[field] !== undefined && formatted[field] !== null && formatted[field] !== '') {
            formatted[field] = formatFinishedGoodsValue(formatted[field], field);
        }
    });
    
    // Format two decimal fields
    finishedGoodsTwoDecimalFields.forEach(field => {
        if (formatted[field] !== undefined && formatted[field] !== null && formatted[field] !== '') {
            formatted[field] = formatFinishedGoodsValue(formatted[field], field);
        }
    });
    
    return formatted;
};

// The Rotli category.
//
// Two screens ask whether a dish is one: Rotli Production, which shows nothing else, and Finished
// Goods, whose Live Rotli Production column reads the Rotli Production screen and so belongs to
// this category alone. Asked here so the two cannot answer it differently.
//
// By name and not by id, because the id is one database's. Either name answers -- a category
// carries a Gujarati one and an English one -- and case does not matter.
const ROTLI_CATEGORY = /rotli|રોટલી/i;
const isRotliCategory = (category) =>
    ROTLI_CATEGORY.test(category?.eng_name ?? '') || ROTLI_CATEGORY.test(category?.name ?? '');

export { baseUrl, limit, batchSize, rotiBatchSize, statusList, timeSlotList, timeList, rotliTypeList, noOfGullaList, reportTypeList, requirementStatusList, issueStatusList, orderStatusList, purchaseStatusList, receiptStatusList, returnReceiptStatusList, generateRequisitionNumber, getDateWithDay, formatDate, formatDateDMY, formatDateForFile, qtyToCrates, cratesToQty, qtyToLtrsKgs, roundQty, addDays, appropriateItemSeason, mahatmaRatings, heightSelectionList, dairyReceiptStatusList, formatMasterReportValue, formatProductionReportValue, formatExcessReportValue, formatSummaryReportValue, formatRecipeFeedbackReportValue, formatFinishedGoodsValue,
    formatFinishedGoodsFormData, isRotliCategory };